import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Grid } from 'react-loader-spinner';

import { sendEvent } from '../../helpers/analyticsHandler';
import { GetProductDetail, SubmitForm } from '../../services/dmpApi';
import Button from '../Button/Button';
import Modal from '../Modal/Modal';
import FormAddToMarketplace from './FormAddToMarketplace';
import FormRequestAccess from './FormRequestAccess';

import './Form.scss';

const FormContainer = ({ id, isOpen, handleClose, header, typeForm, handleClickConfirmation, handleError, asset }) => {
    const requestTypeLabel = ''
    const productIdLabel = ''
    const productNameLabel = ''
    const productTypeLabel = ''
    const productOwnerLabel = ''
    const biLeadLabel = ''

    const [isLoading, setIsLoading] = useState(false);
    const [formFields, setFormFields] = useState({});
    const formHeaders = {
        DIA: 'Summarize your data needs and how the data will be used',
        DAA: 'Who will need access?',
        DSA: 'What will the data be used for?'
    }
    const [submitRedirectToAlation, setSubmitRedirectToAlation] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState('');  

    const requestTypeMapping = {
        'DIA': 'Data Ingestion Request',
        'DSA': 'Data Sharing Request',
        'DAA': 'Data Access Request',
        'DLA': 'Data Lake Access Request',
        'NIR': 'New Idea Request',
        'OR': 'Other Request',
        'NPI' : 'New Project Idea/Enhancement Requests',
        'DQI': 'Log Data Issue/Question',
        'GCR' : 'Gen AI Chatbot Request'
    }

    let clearChildState = null;
    const assignClearChildState = (clearState) => {
        clearChildState = clearState;
    }

    let validateFormSubmission = null;
    const assignValidateFormSubmission = (validate) => {
        validateFormSubmission = validate;
    }

    const handleCloseModal = () => {
        handleClose();
        clearChildState();
        setFormFields({});
    }

    const handleSelectedProduct = (product) => {
        setSelectedAsset(product);
    }

    useEffect(() => {
        if(typeForm==='DAA'){
            setSelectedAsset(asset);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[asset]);

    const handleFormFieldChange = (childState) => {
        setSubmitRedirectToAlation(false);
        setFormFields({...formFields, ...childState});
        if(["Log Data Issue/Question","Data Lake Ingestion Request","Data Lake Access Request"].includes(childState.dropdownRequestType?.value)){
            setSubmitRedirectToAlation(true);
        }
        
    }

    const handleSubmit = async () => {
        if (!validateFormSubmission()) return;
      
        setIsLoading(true);

        const {
            id: assetId = 'None',
            name: assetNameDefault = 'None',
            type: assetTypeDefault = 'None',
            primaryOwners = [],
            secondaryOwners = [],
          } = selectedAsset || {};
        
          let assetType = assetTypeDefault;
          let assetName = assetNameDefault;

        // Handle DIA form type mapping
        const requestType = formFields.dropdownRequestType.value;
        const typeMap = {
          'New Project Idea/Enhancement Requests': 'NPI',
          'Log Data Issue/Question': 'DQI',
          'Data Lake Access Request': 'DLA',
          'PowerBI Access Request': 'DAA',
          'Gen AI Chatbot Request': 'GCR',
        };
      
        if (typeForm === 'DIA' && requestType !== 'Data Lake Ingestion Request') {
          typeForm = typeMap[requestType] || typeForm;
      
          if (['PowerBI Access Request', 'Gen AI Chatbot Request'].includes(requestType)) {
            assetType = requestType === 'PowerBI Access Request' ? 'Dashboard' : 'Gen AI Use Case';
            assetName = formFields.dropdownProductName.value;
          }
        }

        const isRedirectForm = ['DIA', 'DQI', 'DLA'].includes(typeForm);
        let redirectSuccess = false;
      
        if (isRedirectForm) {
          const url = `${process.env.REACT_APP_NRG_ALATION_URL}`;
      
          const newWindow = window.open(url, '_blank');
          redirectSuccess = !!newWindow;
      
          if (!redirectSuccess) {
            handleError(typeForm === 'DLA' ? 'SNOW' : 'collibra');
          }
          setIsLoading(false);

        }else {
            
              const getOwnerEmail = (owners, role) => owners.find(owner => owner.roleName === role)?.email || 'None';
            
              let assetProductOwnerEmail = assetType === 'Gen AI Use Case' ? getOwnerEmail(secondaryOwners, 'Product Owner') : getOwnerEmail(primaryOwners, 'Product Owner');
            
              const assetBILeadEmail = getOwnerEmail(secondaryOwners, 'BI Lead');
              const assetBusinessOwnerEmail = secondaryOwners.filter(owner => owner.roleName === 'Business Sponsor').map(owner => owner.email).join(', ') || 'None';
            
              let assetADGroup = 'None';
            
              if (assetType === 'Gen AI Use Case') {
                try {
                  const response = await GetProductDetail(assetId);
                  assetADGroup = response.data?.relationships?.sources
                    ?.filter(item => item.role === 'ai access is granted by')
                    .map(item => item.name)
                    .join(', ') || 'None';
                } catch (error) {
                  console.error(error);
                }
              }
            
              // Override assetType for specific form types
              if (['DIA', 'DQI'].includes(typeForm)) assetType = 'Ingestion';
            
              const payload = {
                requestType: { prompt: requestTypeLabel, value: requestTypeMapping[typeForm] },
                productId: { prompt: productIdLabel, value: assetId },
                productName: { prompt: productNameLabel, value: assetName },
                productType: { prompt: productTypeLabel, value: assetType },
                productOwner: { prompt: productOwnerLabel, value: assetProductOwnerEmail },
                biLead: { prompt: biLeadLabel, value: assetBILeadEmail },
                requestDate: { prompt: formFields.requestDate.prompt, value: formFields.requestDate.value },
                summary: { prompt: formFields.summary.prompt, value: formFields.summary.value },
                requestedFor: { prompt: formFields.requestedFor.prompt, value: formFields.requestedFor.value },
                businessOwner: { prompt: '', value: assetBusinessOwnerEmail },
                cloudADGroup: { prompt: '', value: assetADGroup },
              };
            
              try {
                await SubmitForm(payload);
                handleClickConfirmation(isRedirectForm ? 'collibra' : '');
                sendEvent('analyticsClickAction', 'modalSubmit', typeForm, null, selectedAsset || null);
              } catch (error) {
                console.error(error);
                handleError(isRedirectForm ? 'collibra' : '');
              } finally {
                setIsLoading(false);
              }
        }
        setFormFields({});
        
      };

    return (
        <>
            {isOpen &&
                <Modal id={id} isOpen={isOpen} handleClose={handleCloseModal} size="md">
                    {header && <div className='modal-header'>{header}</div>}
                    <div className='modal-form-content'>
                        <div className='form'>
                            <div className='form--header'>
                                {formHeaders[typeForm]}
                            </div>
                            <form>        
                                {(typeForm === 'DIA' && <FormAddToMarketplace 
                                    id={id} 
                                    onFieldChange={handleFormFieldChange}
                                    passClearStateFunction={assignClearChildState} 
                                    passValidateFormFunction={assignValidateFormSubmission}
                                    handleSelectedProduct={handleSelectedProduct} />) ||
                                (typeForm === 'DAA' && <FormRequestAccess 
                                    id={id} 
                                    onFieldChange={handleFormFieldChange} 
                                    passClearStateFunction={assignClearChildState} 
                                    passValidateFormFunction={assignValidateFormSubmission}
                                    assetName={asset?.name} />) }
                            </form>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <Button
                            id={`${id}-submit-btn`}
                            className='btn--rounded btn--blue-light btn--submit'
                            onClick={() => handleSubmit()}
                            disabled={isLoading}>
                            {submitRedirectToAlation ? "Submit in Alation" : "Submit"}
                        </Button>
                        {isLoading && <span><Grid color="#999999" height={20} width={20} ariaLabel='loading' wrapperClass="modal-spinner" /></span>}
                    </div>
                </Modal>
            }
        </>
    )
}

FormContainer.propTypes = {
    id: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    header: PropTypes.string,
    typeForm: PropTypes.string,
    handleClickConfirmation: PropTypes.func,
    handleError: PropTypes.func.isRequired,
    asset: PropTypes.any
}

export default FormContainer;